import _ from 'lodash'

const state = {
    mapType: "dark",
    mapContextMenu: {
        active: false,
        lat: null,
        lng: null,
        map: {}
    },
    isSettingBase: false,
    isSettingActivityArea: false
}

const getters = {

}

const mutations = {
    SET_NEXT_MAP_TYPE(state){
        const mapTypes = ["dark","blue","light","dark-grey","shades-of-gray","simply-dark"]
        const indexOfMapType = mapTypes.indexOf(state.mapType)
        if((indexOfMapType + 1) === mapTypes.length){
            state.mapType = mapTypes[0]
        }
        else {
            state.mapType = mapTypes[indexOfMapType + 1]
        }
        return state.mapType
    },
    SET_MAP_CONTEXT_MENU(state, mapContextMenu){
        _.assign(state.mapContextMenu, mapContextMenu)
    },
    SET_IS_SETTING_BASE(state, isSettingBase) {
        state.isSettingBase = isSettingBase
    },
    SET_IS_SETTING_ACTIVITY_AREA(state, isSettingActivityArea) {
        state.isSettingActivityArea = isSettingActivityArea
    }
}

const actions = {
    setNextMapType(context){
        return context.commit('SET_NEXT_MAP_TYPE')
    },
    setIsSettingBase(context, isSettingBase) {
        context.commit('SET_IS_SETTING_BASE', isSettingBase)
    },
    setIsSettingActivityArea(context, isSettingActivityArea) {
        context.commit('SET_IS_SETTING_ACTIVITY_AREA', isSettingActivityArea)
    }
}

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}